import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'SupplierIndex',
    component: () => import('@/views/supplier/Index'),
    meta: { title: '找货-供应商' }
  },
  {
    path: '/supplier/detail/id/:id',
    name: 'SupplierDetail',
    component: () => import('@/views/supplier/Detail'),
    meta: { title: '找货-供应商-详情' }
  },
  {
    path: '/category/index',
    name: 'CategoryIndex',
    component: () => import('@/views/category/Index'),
    meta: { title: '找货-分类' }
  },
  {
    path: '/brand/index',
    name: 'BrandIndex',
    component: () => import('@/views/brand/Index'),
    meta: { title: '找货-品牌' }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
